import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BiHeadphone, BiVolumeMute } from "react-icons/bi";
import axios from "../../../axios";
import SpinnerLoader from "../../../components/UI/SpinnerLoader/SpinnerLoader";
import * as url from "../../../utils/url";
import trivvyLogo from "../../../assets/trivvy/trivvy-logo-img.png";
import "./audio-link.css";

// Bug923: landing page for hashtag audio short links — /a/:code, texted to
// hashtag admins. No login: the BE resolves the code to a fresh short-lived
// S3 URL and we replace this page with it, so the browser plays or downloads
// the original file and Back doesn't bounce through here again. Only an
// https S3 URL is followed (defense in depth; the BE builds it itself).
const isSignedS3Url = (value) => {
  try {
    const parsed = new URL(value);
    return parsed.protocol === "https:" && /\.amazonaws\.com$/i.test(parsed.hostname);
  } catch (e) {
    return false;
  }
};

const AudioLinkRedirect = ({ match }) => {
  const [isUnavailable, setIsUnavailable] = useState(false);

  useEffect(() => {
    axios
      .get(url.resolveAudioLinkPublic(match.params.code))
      .then((res) => {
        const audioUrl = res.data && res.data.data && res.data.data.url;
        if (isSignedS3Url(audioUrl)) {
          window.location.replace(audioUrl);
        } else {
          setIsUnavailable(true);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsUnavailable(true);
      });
  }, [match.params.code]);

  if (isUnavailable) {
    return (
      <div className="audio_link_page">
        <div className="audio_link_card">
          <img src={trivvyLogo} alt="Trivvy" className="audio_link_logo" />
          <div>
            <span className="audio_link_icon audio_link_icon_muted">
              <BiVolumeMute />
            </span>
          </div>
          <h1 className="audio_link_title">Audio not available</h1>
          <p className="audio_link_text">
            This audio link is invalid or no longer available. The hashtag may have been removed.
          </p>
          <Link to="/" className="audio_link_button">
            Open Trivvy
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="audio_link_page">
      <div className="audio_link_card">
        <img src={trivvyLogo} alt="Trivvy" className="audio_link_logo" />
        <div>
          <span className="audio_link_icon">
            <BiHeadphone />
          </span>
        </div>
        <h1 className="audio_link_title">Opening audio…</h1>
        <p className="audio_link_text">Your audio will start in a moment.</p>
        <div className="audio_link_loader">
          <SpinnerLoader />
        </div>
      </div>
    </div>
  );
};

export default AudioLinkRedirect;
